import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LaunchLanding from "./sections/v2/Launch";
import AdminReadiness from "./pages/AdminReadiness";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LaunchLanding />} />
        <Route path="/admin/readiness" element={<AdminReadiness />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
